
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class TableBadge extends Vue {
  @Prop(String) readonly badge!: string;
  @Prop(String) readonly color!: string;
}
